import z from "zod";

import { zCatalog } from "../catalog/ZCatalog";
import { zSecSpecLinkType, zSpecCommon } from "./ZSpecification";

const zCatalogLight = zCatalog.omit({ schema: true });

export const zSecSpecRow = z.object({
  ...zSpecCommon.shape,
  linkType: zSecSpecLinkType,
  catalogs: zCatalogLight.array().nullish(),
});

export type ZSecSpecRow = z.infer<typeof zSecSpecRow>;

export const zAvailableSecSpecRow = z.object({
  ...zSpecCommon.shape,
  categoryData: zSecSpecLinkType.nullish(),
});
export type ZAvailableSecSpecRow = z.infer<typeof zAvailableSecSpecRow>;

export type SecSpecsFilter = { text?: string };
export type AvailSecSpecsFilter = { text?: string };
